import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { apiService } from '../services/api';
import { preloadImages } from '../utils/imagePreloader';

const useCasesStore = create(devtools((set, get) => ({
	cases: [],
	loading: false,
	error: null,
	wasLoaded: false,
	imagesLoaded: false,

	fetchCases: async () => {
		if (get().wasLoaded) return;
		set({ loading: true, error: null });
		try {
			const response = await apiService.getCases();
			// response должен быть массивом кейсов
			set({ cases: response, loading: false, wasLoaded: true });

			// Предварительная загрузка изображений
			const allItemImages = response.reduce((acc, currentCase) => {
				const itemImages = (currentCase.items || []).map(item => item.icon_url);
				return [...acc, ...itemImages];
			}, []);

			// Загружаем изображения в фоне
			preloadImages(allItemImages)
				.then(() => {
					set({ imagesLoaded: true });
					console.log('Все изображения предварительно загружены');
				})
				.catch(error => {
					console.error('Ошибка при предварительной загрузке изображений:', error);
				});
		} catch (err) {
			set({ error: err.message || 'Ошибка при загрузке кейсов', loading: false });
		}
	}
}), { name: 'CasesStore' }));

export default useCasesStore;
